module.exports = __webpack_public_path__ + "static/img/4.084ca80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/eng/4.png
// module id = oQBa
// module chunks = 0